import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { baseUrl, config, requestID } from '../../common/utils';

interface Props {
  open: boolean;
  onClose: () => void;
  userId: number;
  banklist: any[]; // you can replace `any` with a proper type if you have one
}

const UpdateBankDetailsModal: React.FC<Props> = ({ open, onClose, userId,  banklist,
  }) => {
  const [form, setForm] = useState({
    accountNumber: '',
    accountName: '',
    bankName: '',
    registered_bankCode: ''
  });

    const [accountName, setAccountName] = useState(""); // Added
    const [status, setStatus] = useState({ loading: false, error: false });

console.log({banklist})
  useEffect(() => {
    if (open) {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("user_id", String(userId));

      axios
        .post(`${baseUrl()}users/getBankDetails`, formData,config)
        .then((res) => {
          console.log(res);
          setForm(res.data);
        })
        .catch(() => alert('Failed to fetch bank details'));
    }

    
  }, [open, userId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
      setLoading(true); // Start loading

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("user_id", String(userId));
    formData.append("accountNumber", form.accountNumber);
    formData.append("accountName", form.accountName ); // Use the fetched account name if available
    formData.append("bankName", form.bankName);
    formData.append("registered_bankCode", form.registered_bankCode);

    try {
      const response = await axios.post(
        `${baseUrl()}users/updateBankDetails`,
        formData, config
      );
      console.log(response);
      alert(response.data.message || 'Bank details updated');
      onClose();
    } catch (error) {
      alert('Failed to update bank details');
    }
  };
    const [bankCode, setBankCode] = useState("");
       const getAccountName = async (id) => {
        console
        // try {
        setStatus({ loading: true, error: false });
        const formData = new FormData();
        formData.append("requestID", requestID());
           formData.append("accountNumber", id);
        formData.append("bankCode", bankCode);
  
        console.log(formData);
        const response = await axios.post(
          baseUrl() + "warehouses/getAccountName",
          formData,
          config
        );
        console.log( response );
       // const data = await response.data.data;
        setAccountName(response.data.data);
          setForm((prev) => ({
    ...prev,
     accountName: response.data.data
  }));
       // form.accountName(response.data.data);
        setStatus({ loading: false, error: false });
      };
  

      const isFormValid =
  form.registered_bankCode.trim() !== '' &&
  form.accountNumber.trim() !== '' &&
  form.accountName.trim() !== '';

   const [loading, setLoading] = useState(false);
/* const handleSubmit = async () => {
  setLoading(true); // Start loading
  try {
    const response = await axios.post(
      `${baseUrl()}users/updateBankDetails`,
      { user_id: userId, ...form },
      config
    );
    alert(response.data.message || 'Bank details updated');
    onClose();
  } catch (error) {
    alert('Failed to update bank details');
  } finally {
    setLoading(false); // Stop loading
  }
}; */
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          px: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            position: 'relative',
            width: '100%',
            maxWidth: 500,
            borderRadius: 2,
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" gutterBottom>
            Update Bank Details
          </Typography>

                   <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Bank List</InputLabel>
            <Select
              value={form.registered_bankCode}
              label="Select Bank"
                          name="registered_bankCode"
onChange={(e) => {
  setBankCode(e.target.value);
  handleChange(e);
  setForm((prev) => ({
    ...prev,
    accountNumber: '',
    accountName: ''
  }));
}}

            >
              {banklist?.map((banklist, index) => (
                  <MenuItem key={index} value={banklist.code}>
                    {banklist.name.toUpperCase()} 
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
{/*  <TextField
            fullWidth
            margin="normal"
            name="bankName"
            label="Bank Name"
            value={form.name}
            onChange={handleChange}
          /> */}
      <TextField
  fullWidth
  name="accountNumber"
  margin='normal'
  autoComplete="off"
  type="number"
  label="Account Number"
  value={form.accountNumber}
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Update the form state
    setForm((prev) => ({
      ...prev,
      accountNumber: value
    }));

    // When value reaches 10 digits, call the API
    if (value.length === 10) {
    //  alert('Fetching account name...');
      getAccountName(value);
    }
  }}
/>
      <TextField
  fullWidth
  margin="normal"
  name="accountName"
  label="Account Name"
  value={form.accountName}
  InputProps={{
    readOnly: true,
  }}
/>


   
          {/* <TextField
            fullWidth
            margin="normal"
            name="registered_bankCode"
            label="Bank Code"
            value={form.registered_bankCode}
            onChange={handleChange}
          /> */}

   <Button
  variant="contained"
  color="primary"
  sx={{ mt: 3 }}
  onClick={handleSubmit}
  fullWidth
  disabled={!isFormValid || loading}
>
  {loading ? 'Saving...' : 'Save Changes'}
</Button>
        </Paper>
      </Box>
    </Modal>
  );
};

export default UpdateBankDetailsModal;
